export const isUnauthorizedError = (error: string | Error | null): boolean => {
    if (!error) return false;

    // Check for LDAP group error flag
    if (typeof error === 'object' && error !== null && 'isLdapGroupError' in error) {
        return (error as any).isLdapGroupError === true;
    }

    // Fallback: Check for 403 in message
    const errorMessage = typeof error === 'string' ? error : error.message;
    if (errorMessage?.includes('403')) return true;

    // Fallback: Check for 403 status code in response
    if (typeof error === 'object' && error !== null && 'response' in error) {
        const response = (error as any).response;
        if (response?.status === 403) return true;
    }

    return false;
};
